import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Row, Col, Button, Form, Card, InputGroup } from 'react-bootstrap';
import Layout from '../../layout/Layout';
import Switch from "react-switch";
import { API } from "../../App"
import { toast } from 'react-toastify';
import Cookies from 'js-cookie'
import Fancybox from '../../Component/FancyBox';

const DefultThemeEdit = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [LoadData, setLoadData] = useState([])
  const [validate, setValidate] = useState(false)
  const [IsSelected, setIsSelected] = useState(false);
  const [selectedfile, setSelectedfile] = useState(null);
  const [loading, setLoading] = useState(false)
  const [cat, setCategory] = useState([])
  const [keyboardCategories, setKeyboardCategories] = useState([]) // Add this line
  const [selectedCategory, setSelectedCategory] = useState('') // Add this line

  const fetchKeyboardCategories = async () => {
    try {
      const token = Cookies.get('jwt')
      const res = await API.post('/keyboardCategories', {}, { 
        headers: { "authorization": `Bearer ${token}` } 
      })
      setKeyboardCategories(res.data.data || [])
    } catch (error) {
      console.error('Error fetching keyboard categories:', error)
    }
  }

  const lodadata = async () => {
    setLoading(true)
    const token = Cookies.get('jwt')
    const res = await API.post(`/normalImages/${id}`, {}, { headers: { "authorization": `Bearer ${token}` } })

    setuser({
      rank: res.data.data.rank,
      normal_image: res.data.data.normal_image,
      name: res.data.data.name,
      key_bord_Back_Color: res.data.data.key_bord_Back_Color,
      key_Back_Color: res.data.data.key_Back_Color,
      btn_Back_Color: res.data.data.btn_Back_Color,
      btn_Key_Color: res.data.data.btn_Key_Color,
      is_Border: res.data.data.is_Border,
      popup_Back_Color: res.data.data.popup_Back_Color,
      popup_Text_Color: res.data.data.popup_Text_Color,
      status: res.data.data.status,
      border_Color: res.data.data.border_Color,
      text_Color_For_Show_Key_Off: res.data.data.text_Color_For_Show_Key_Off,
      is_premium: res.data.data.is_premium,
      is_Watch_Video: res.data.data.is_Watch_Video,
      created_at: res.data.data.created_at,
      isImg: res.data.data.isImg,
      updated_at: res.data.data.updated_at,
      keyboardCategory: res.data.data.keyboardCategory
    })
    setLoadData(res.data.data)
    setSelectedCategory(res.data.data.keyboardCategory || '')
    const catRes = await API.post(`/normalImages`)
    setCategory(catRes.data.data)
    setLoading(false)
  }

  useEffect(() => {
    lodadata()
    fetchKeyboardCategories()
  }, [])

  const [user, setuser] = useState({
    rank: "",
    name: "",
    key_bord_Back_Color: "#0d0d0d",
    key_Back_Color: "#0d0d0d",
    btn_Back_Color: "#0d0d0d",
    btn_Key_Color: "#0d0d0d",
    popup_Back_Color: "#0d0d0d",
    view_Back_Color: "#0d0d0d",
    popup_Text_Color: "#0d0d0d",
    border_Color: "#0d0d0d",
    text_Color_For_Show_Key_Off: "#0d0d0d",
    status: "",
    is_premium: "",
    is_Border: "",
    is_Watch_Video: "",
    isImg: ""

  })

  const handdelsubmission = async () => {
    console.log('helo')
    if (user.rank === "" || !user.rank) {
      setValidate(true)
    }
    else if (user.name === "" || !user.name) {
      setValidate(true)
    }
    else if (user.key_bord_Back_Color === "" || !user.key_bord_Back_Color) {
      setValidate(true)
    }
    else if (user.key_Back_Color === "" || !user.key_Back_Color) {
      setValidate(true)
    }
    else if (user.btn_Back_Color === "" || !user.btn_Back_Color) {
      setValidate(true)
    }
    else if (user.popup_Back_Color === "" || !user.popup_Back_Color) {
      setValidate(true)
    }
    else if (user.popup_Text_Color === "" || !user.popup_Text_Color) {
      setValidate(true)
    }
    else if (user.border_Color === "" || !user.border_Color) {
      setValidate(true)
    }
    else if (user.text_Color_For_Show_Key_Off === "" || !user.text_Color_For_Show_Key_Off) {
      setValidate(true)
    }
    else {
      console.log('test')
      const formdata = new FormData()
      formdata.append("rank", user.rank)
      formdata.append("name", user.name)
      formdata.append("key_bord_Back_Color", user.key_bord_Back_Color)
      formdata.append("key_Back_Color", user.key_Back_Color)
      formdata.append("btn_Key_Color", user.btn_Key_Color)
      formdata.append("btn_Back_Color", user.btn_Back_Color)
      formdata.append("popup_Back_Color", user.popup_Back_Color)
      formdata.append("view_Back_Color", user.view_Back_Color)
      formdata.append("popup_Text_Color", user.popup_Text_Color)
      formdata.append("border_Color", user.border_Color)
      formdata.append("text_Color_For_Show_Key_Off", user.text_Color_For_Show_Key_Off)
      formdata.append("normal_image", selectedfile)
      formdata.append("status", user.status)
      formdata.append("is_premium", user.is_premium)
      formdata.append("is_Border", user.is_Border)
      formdata.append("is_Watch_Video", user.is_Watch_Video)
      formdata.append("isImg", user.isImg)
      formdata.append("keyboardCategory", selectedCategory)

      setLoading(true)
      const token = Cookies.get('jwt')
      const res = await API.post(`/normalImagesUpdate/${id}`, formdata, { headers: { "authorization": `Bearer ${token}` } })
      console.log(res, 'res')
      if (res.data.status === true) {
        navigate(`/defaulttheme/view/${id}`)
        toast.success("Data Save Sucessfully", { position: "bottom-right", autoClose: 500 })
      }

    }
  }

  function printColor(color) {
    const r = parseInt(color.substr(1,2), 16)
    const g = parseInt(color.substr(3,2), 16)
    const b = parseInt(color.substr(5,2), 16)
   return "rgb("+r+","+g+","+ b + ")"
  }

  const onInputchange = async (e) => {
    var color = ["text_Color_For_Show_Key_Off",'border_Color','popup_Text_Color','popup_Back_Color','btn_Key_Color','btn_Back_Color','key_Back_Color','key_bord_Back_Color']
    if(color.includes(e.target.name))
    {
      const rgb = await printColor(e.target.value)
      setuser({ ...user, [e.target.name]: rgb })
    }
    else
    {
      setuser({ ...user, [e.target.name]: e.target.value })
    }

  }

  const changeHandler = (event) => {
    console.log(event.target.files[0])
    setSelectedfile(event.target.files[0]);
    setIsSelected(true);

  }

  const statuschanges = (e) => {
    const result = (e === true) ? true : false
    setuser({
      ...user, ['status']: result
    })
  }

  const borderchange = (e) => {
    const result = (e === true) ? true : false
    setuser({
      ...user, ['is_Border']: result
    })
  }

  const premiumchange = (e) => {
    const result = (e === true) ? true : false
    setuser({
      ...user, ['is_premium']: result
    })
  }


  const isImgchange = (e) => {
    const result = (e === true) ? true : false
    setuser({
      ...user, ['isImg']: result
    })
  }


  const watchchange = (e) => {
    const result = (e === true) ? true : false
    setuser({
      ...user, ['is_Watch_Video']: result
    })
  }

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3 className="my-1"> Edit Defult Theme</h3>
        <Row className="align-items-center">
        </Row>
      </div>
      <div className="page-content">
        <Form noValidate validated={validate}>
          <Row>
            <Col xs={12}>
              <Card className="mb-4">
                <Card.Body>
                  {
                    loading ? <div className='loader table-loader' ></div> : <></>
                  }
                  <Row>
                    <Col lg={3} sm={12}>
                      <Form.Group >
                        <Form.Label htmlFor="m_cate" >New Index</Form.Label>
                        <Form.Control type="number" id='cate-img' value={user.rank} className="my-2" readOnly />
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group >
                        <Form.Label htmlFor="cate" >Name</Form.Label>
                        <Form.Control type="text" id='cate' className="my-2" value={user.name} name="name" onChange={onInputchange} required />
                        <Form.Control.Feedback type="invalid">
                          Enter Name
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group>
                        <Form.Label htmlFor="cate-img" >Normal Image</Form.Label>
                        <InputGroup className='my-2'>
                          <Form.Control type="file" id='cate-img'  name='normal_image' onChange={changeHandler} />
                          <Fancybox>
                            <a data-fancybox="gallery" href={user.normal_image}>
                              <img src={user.normal_image} className='hv-40 rounded-3' alt="" />
                            </a>
                          </Fancybox>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group>
                        <Form.Label htmlFor="keyboardCategory">Keyboard Category</Form.Label>
                        <Form.Select 
                          id="keyboardCategory" 
                          className="my-2"
                          value={selectedCategory}
                          onChange={(e) => setSelectedCategory(e.target.value)}
                        >
                          <option value="">Select Keyboard Category</option>
                          {keyboardCategories.map(category => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm="12" className='mb-2'>
                      <Form.Label htmlFor="media_type" className='d-block mb-2'>Status</Form.Label>
                      <Switch
                        onChange={statuschanges}
                        checked={user.status === true ? true : false}
                        offColor="#C8C8C8"
                        onColor="#0093ed"
                        height={30}
                        width={70}
                        className="react-switch"
                        uncheckedIcon={
                          <div className='react-switch-off'>OFF</div>
                        }
                        checkedIcon={
                          <div className='react-switch-on'>ON</div>
                        }
                      />
                    </Col>
                    <Col lg={3} sm="12" className='mb-2'>
                      <Form.Label htmlFor="media_type" className='d-block mb-2'>Is Premium</Form.Label>
                      <Switch
                        onChange={premiumchange}
                        checked={user.is_premium === true ? true : false}
                        offColor="#C8C8C8"
                        onColor="#0093ed"
                        height={30}
                        width={70}
                        className="react-switch"
                        uncheckedIcon={
                          <div className='react-switch-off'>NO</div>
                        }
                        checkedIcon={
                          <div className='react-switch-on'>YES</div>
                        }
                      />
                    </Col>
                    <Col lg={3} sm="12" className='mb-2'>
                      <Form.Label htmlFor="media_type" className='d-block mb-2'>Is Border</Form.Label>
                      <Switch
                        onChange={borderchange}
                        checked={user.is_Border === true ? true : false}
                        offColor="#C8C8C8"
                        onColor="#0093ed"
                        height={30}
                        width={70}
                        className="react-switch"
                        uncheckedIcon={
                          <div className='react-switch-off'>NO</div>
                        }
                        checkedIcon={
                          <div className='react-switch-on'>YES</div>
                        }
                      />
                    </Col>
                    <Col lg={3} sm="12" className='mb-2'>
                      <Form.Label htmlFor="media_type" className='d-block mb-2'>Is Watch Video</Form.Label>
                      <Switch
                        onChange={watchchange}
                        checked={user.is_Watch_Video === true ? true : false}
                        offColor="#C8C8C8"
                        onColor="#0093ed"
                        height={30}
                        width={70}
                        className="react-switch"
                        uncheckedIcon={
                          <div className='react-switch-off'>OFF</div>
                        }
                        checkedIcon={
                          <div className='react-switch-on'>ON</div>
                        }
                      />
                    </Col>
                    <Col lg={3} sm="12" className='mb-2'>
                      <Form.Label htmlFor="media_type" className='d-block mb-2'>Is Image</Form.Label>
                      <Switch
                        onChange={isImgchange}
                        checked={user.isImg === true ? true : false}
                        offColor="#C8C8C8"
                        onColor="#0093ed"
                        height={30}
                        width={70}
                        className="react-switch"
                        uncheckedIcon={
                          <div className='react-switch-off'>OFF</div>
                        }
                        checkedIcon={
                          <div className='react-switch-on'>ON</div>
                        }
                      />
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group >
                        <Form.Label htmlFor="cate" >Keyboard BackColor</Form.Label>
                        <div className='color-box-group'>
                          <Form.Control type="color" className="my-2" value={user.key_bord_Back_Color} name='key_bord_Back_Color' onChange={onInputchange} />
                          <div className='color-box' style={{ backgroundColor:user.key_bord_Back_Color }}></div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group >
                        <Form.Label htmlFor="cate" >Key BackColor</Form.Label>
                        <div className='color-box-group'>
                          <Form.Control type="color" className="my-2" value={user.key_Back_Color} name='key_Back_Color' onChange={onInputchange} />
                          <div className='color-box' style={{ backgroundColor:user.key_Back_Color }}></div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group >
                        <Form.Label htmlFor="cate" >Button BackColor</Form.Label>
                        <div className='color-box-group'>
                          <Form.Control type="color" className="my-2" value={user.btn_Back_Color} name='btn_Back_Color' onChange={onInputchange} />
                          <div className='color-box' style={{ backgroundColor:user.btn_Back_Color }}></div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group >
                        <Form.Label htmlFor="cate" >Button KeyColor</Form.Label>
                        <div className='color-box-group'>
                          <Form.Control type="color" className="my-2" value={user.btn_Key_Color} name='btn_Key_Color' onChange={onInputchange} />
                          <div className='color-box' style={{ backgroundColor:user.btn_Key_Color }}></div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group >
                        <Form.Label htmlFor="cate" >Popup Back Color</Form.Label>
                        <div className='color-box-group'>
                          <Form.Control type="color" className="my-2" value={user.popup_Back_Color} name='popup_Back_Color' onChange={onInputchange} />
                          <div className='color-box' style={{ backgroundColor:user.popup_Back_Color }}></div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group >
                        <Form.Label htmlFor="cate" >Popup Text Color</Form.Label>
                        <div className='color-box-group'>
                          <Form.Control type="color" className="my-2" value={user.popup_Text_Color} name='popup_Text_Color' onChange={onInputchange} />
                          <div className='color-box' style={{ backgroundColor:user.popup_Text_Color }}></div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group >
                        <Form.Label htmlFor="cate" >Border Color</Form.Label>
                        <div className='color-box-group'>
                          <Form.Control type="color" className="my-2" value={user.border_Color} name='border_Color' onChange={onInputchange} />
                          <div className='color-box' style={{ backgroundColor:user.border_Color }}></div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group >
                        <Form.Label htmlFor="cate" >TextColor For ShowKeyOff</Form.Label>
                        <div className='color-box-group'>
                          <Form.Control type="color" className="my-2" value={user.text_Color_For_Show_Key_Off} name='text_Color_For_Show_Key_Off' onChange={onInputchange} />
                          <div className='color-box' style={{ backgroundColor:user.text_Color_For_Show_Key_Off }}></div>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
                <Card.Footer className="text-end">
                  <Button variant="primary" className="me-3" onClick={handdelsubmission}>Save</Button>
                  <Link to="/defaulttheme">
                    <Button variant="secondary">Cancle</Button>
                  </Link>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Form>
      </div>
    </Layout>
  )
}

export default DefultThemeEdit